import "./Channel.scss";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import partnersApi from "../../apis/Partners.api";
import CommunityRecommend from "../../components/channel/home/CommunityRecommend";
import HomeBanner from "../../components/channel/home/HomeBanner";
// import HomeGroupBuying from "../../components/channel/home/HomeGroupBuying";
import HomeCommunity from "../../components/channel/home/HomeCommunity";
import HomeNotice from "../../components/channel/home/HomeNotice";

const HomeSquidtv = () => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);

	// const [combiList, setCombiList] = useState([]);
	const [ingreList, setIngreList] = useState([]);
	// const [funcList, setFuncList] = useState([]);
	//
	// const [nowList, setNowList] = useState([]);
	// const [readyList, setReadyList] = useState([]);
	//
	// const [alertShow, setAlertShow] = useState(false);

	const [mediaResult, setMediaResult] = useState(null);
	useEffect(() => {
		if (typeof window !== "undefined") {
			const matchQueryList = window.matchMedia("all and (max-width: 768px)");
			setMediaResult(matchQueryList.matches);

			const media = function handleChange(e) {
				setMediaResult(e.matches);
			};

			matchQueryList.addEventListener("change", media);
		}
	}, []);

	useEffect(() => {
		if (reduxChannel?.user_id) {
			getCategory();
			// getGroupBuying();
		}
	}, [reduxChannel, mediaResult]);
	// useEffect(() => {
	//     window.scrollTo({
	//         top: Number(beforeScroll),
	//     })
	// }, [beforeScroll])

	/**
	 * 홈화면 리스트 가져오기
	 * @returns {Promise<void>}
	 */
	const getCategory = async () => {
		let param = {
			offset: 0,
			// pageSize: mediaResult ? 6 : 8,
			pageSize: 6,
			// pageSize: 8,
			categoryType: "home",
			influencerId: reduxChannel.user_id,
		};
		const res = await partnersApi.togetherCategoryRead(param);
		if (res.code === 200) {
			// let combi = res.result?.recommendCombinationList?.map((item) => ({
			//     ...item,
			//     bg_color: item.is_hot ? "#FF8000" :
			//         item.is_best ? "#005DA9" :
			//             reduxChannel?.color_1 ? reduxChannel?.color_1 : "#272847"
			// }))
			let ingre = res.result?.ingredientList?.map((item) => ({
				...item,
				bg_color: item.is_hot
					? "#FF8000"
					: item.is_best
					? "#005DA9"
					: reduxChannel?.color_2
					? reduxChannel?.color_2
					: "#272847",
			}));
			// let func = res.result?.functionList?.map((item) => ({
			//     ...item,
			//     bg_color: item.is_hot ? "#FF8000" :
			//         item.is_best ? "#005DA9" :
			//             reduxChannel?.color_1 ? reduxChannel?.color_1 : "#272847"
			// }))
			// setCombiList(combi);
			setIngreList(ingre);
			// setFuncList(func);

			// const beforeScroll = sessionStorage.getItem("scroll");
			//
			// window.scrollTo({
			//     top: Number(beforeScroll),
			//     behavior: 'smooth'
			// })
		}
	};

	if (reduxChannel?.influencer_id) {
		return (
			<div className={`channel-wrap channel-home channel-delay`}>
				{mediaResult ? (
					<>
						<HomeBanner />
						<HomeNotice />
						<HomeCommunity ingreList={ingreList} />
					</>
				) : (
					<div className={`home-channel-triple`}>
						<div
							className={`max-width-apply`}
							style={{
								display: "flex",
								width: "100%",
								gap: "2%",
							}}
						>
							<HomeBanner />
							<HomeCommunity ingreList={ingreList} />
							<CommunityRecommend
								type={"ingredient"}
								categoryList={ingreList}
							/>
						</div>
					</div>
				)}
				{/*/!* 채널 한마디 *!/*/}
				{/*{reduxChannel?.user_id === 7 && (*/}
				{/*    <HomeChemist*/}
				{/*        nowList={nowList}*/}
				{/*        readyList={readyList}*/}
				{/*    />*/}
				{/*)}*/}

				{/* 공구 이벤트 */}
				{/*<GroupBuyingEvent/>*/}

				{/* 가장 많이 물어보는 질문 */}
				{/*<HomeFaq/>*/}

				{/*/!* 조합별 *!/*/}
				{/*{reduxChannel?.combination_menu_show && (*/}
				{/*    <HomeRecommendVertical*/}
				{/*        type={"combination"}*/}
				{/*        categoryList={combiList}*/}
				{/*    />*/}
				{/*)}*/}

				{/*/!* 고민별 *!/*/}
				{/*{reduxChannel?.function_menu_show && (*/}
				{/*    <HomeRecommendVertical*/}
				{/*        type={"function"}*/}
				{/*        categoryList={funcList}*/}
				{/*    />*/}
				{/*)}*/}

				{/*/!* 한마디 *!/*/}
				{/*{reduxChannel?.user_id !== 7 && (*/}
				{/*    <HomeMention/>*/}
				{/*)}*/}

				{/*/!* 공구 알림 받기 - modal *!/*/}
				{/*{alertShow && (*/}
				{/*    <GroupBuyingModal*/}
				{/*        alertShow={alertShow}*/}
				{/*        setAlertShow={setAlertShow}*/}
				{/*    />*/}
				{/*)}*/}
			</div>
		);
	} else {
		return <></>;
	}
};
export default HomeSquidtv;
